<div class="rc-spinner">
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
  <div class="rc-spinner__blade"></div>
</div>
